import { reviewablePlaceHolder } from "features/reviewable/types/placeholder";
import { useQuery } from "react-query";
import { ApiError, api } from "utils/api";
import { Artist } from "../types";

const artistPlaceHolder = (id: string): Artist => ({
  ...reviewablePlaceHolder(id),
  type: "ARTIST",
  artistCollections: [],
});

const getArtistById = (projectId: string) => api(`/artists/${projectId}`);

const useArtist = (artistId: string) =>
  useQuery<Artist, ApiError>(
    ["ARTIST", artistId],
    () => getArtistById(artistId),
    {
      enabled: !!artistId,
      initialData: artistPlaceHolder(artistId),
    }
  );

export { useArtist, artistPlaceHolder, getArtistById };
